function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  id: "Traado",
  fill: "#969fb7",
  stroke: "none",
  d: "M 11.860848 8.464287 L 19.142462 0 L 17.416952 0 L 11.094328 7.349422 L 6.044466 0 L 0.220049 0 L 7.85643 11.113626 L 0.220049 19.989731 L 1.945656 19.989731 L 8.622511 12.228493 L 13.955534 19.989731 L 19.779951 19.989731 L 11.860424 8.464287 L 11.860848 8.464287 Z M 9.497392 11.21154 L 8.723668 10.104874 L 2.567417 1.299011 L 5.217848 1.299011 L 10.186014 8.405623 L 10.95974 9.51229 L 17.417767 18.749798 L 14.767336 18.749798 L 9.497392 11.211965 L 9.497392 11.21154 Z"
});

const SvgIconXDisable = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconXDisable, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-x-disable.8484f1ff.svg";
export { ForwardRef as ReactComponent };